const Add = require("./add").default;
const Apps = require("./apps").default;
const ArrowDown = require("./arrowDown").default;
const ArrowLeft = require("./arrowLeft").default;
const ArrowRight = require("./arrowRight").default;
const ArrowTop = require("./arrowTop").default;
const Basket = require("./basket").default;
const Help = require("./help").default;
const Ok = require("./ok").default;
const Filter = require("./filter").default;
const FilterClear = require("./filterClear").default;
const Search = require("./search").default;

exports.default = {
  Add,
  Apps,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowTop,
  Basket,
  Help,
  Ok,
  Filter,
  FilterClear,
  Search
};
